/* eslint-disable import/prefer-default-export */
/* eslint-disable lines-between-class-members */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { DirectionData, PrefijoPais } from '../../types/PersonalData';
import { GoogleLocation, ItemGoogle } from '../../types/Types';
import { MisDatosService } from '../../services';
import { MisDatosConstants } from '../../utils/MisDatosConstants';
import { DirectionAutocompleteDomIds } from './forms/directionFormIds';

export class DirectionsHelper {
  TAG_BLOQUEADA = 'bloqued';
  TAG_DESABILITADA = 'disabled';
  TIPODATOGEOLOCALIZACION_PAIS = '(regions)';
  TIPODATOGEOLOCALIZACION_DIRECCIO = 'address';
  TIPOGEOLOCALIZACION_CODIGOPOSTAL = 'CP';
  TIPOGEOLOCALIZACION_NOMBREVIA = 'NV';
  SESSION_TOKEN_KEY = 'sessiontoken';
  CORRECT_STATUS = 'OK';
  expRegCodPostalEspania = new RegExp(/(^[0-9]{5}$)/);
  expRegCodPostalAndorra = new RegExp(
    /(^[0-9]{3}[0-9]*$)|(^[Aa][Dd][1234567]0{0,2}$)/,
  );
  regexpInicioCpTlfGibraltar = new RegExp(
    /(^[0-9]{3}[0-9]*$)|^(GX1)[0-9a-z]*$/i,
  );
  expRegCPOnlyGibraltar = new RegExp(/^(GX11 1AA)$/);
  expRegCPOnlyAndorra = new RegExp(/^[Aa][Dd][1234567]0{0,2}$/);

  private getCorrectedGibraltarPostalCode = (postalCodeParameter: string) => {
    let codigoPostal = postalCodeParameter;
    if (codigoPostal === 'GX111AA') {
      codigoPostal = MisDatosConstants.CODIGO_POSTAL_GIBRALTAR;
    }

    return codigoPostal;
  };

  checkIfCPIsGibraltar = (postalCode: string) => {
    let isGibraltar = false;
    if (this.expRegCPOnlyGibraltar.test(postalCode)) {
      isGibraltar = true;
    }
    return isGibraltar;
  };

  checkIfCPIsAndorra = (postalCode: string) => {
    let isAndorra = false;
    if (this.expRegCPOnlyAndorra.test(postalCode)) {
      isAndorra = true;
    }
    return isAndorra;
  };

  setInitialCountryByPostalCode = (isEroski: boolean) => {
    let country = 'country:es';
    if (isEroski) {
      country = `${country}|country:gi`;
    } else {
      country = `${country}|country:ad`;
    }
    return country;
  };

  setCountryByPostalCode = (postalCode: string) => {
    let country = 'country:es';
    if (this.checkIfCPIsGibraltar(postalCode)) {
      country = 'country:gi';
    } else if (this.checkIfCPIsAndorra(postalCode)) {
      country = 'country:ad';
    }
    return country;
  };

  private completarCPconAutocomplete = (
    domIds: DirectionAutocompleteDomIds,
    cp: string,
  ) => {
    const codPostalInput = document.getElementById(
      domIds.postalCode,
    ) as HTMLInputElement;
    codPostalInput.value = cp;
  };

  private completarLocalidadconAutocomplete = (
    domIds: DirectionAutocompleteDomIds,
    locality: string,
  ) => {
    const localityInput = document.getElementById(
      domIds.locality,
    ) as HTMLInputElement;
    localityInput.value = locality;
  };

  private completarViaconAutocomplete = (
    domIds: DirectionAutocompleteDomIds,
    via: string,
  ) => {
    const codPostalInput = document.getElementById(
      domIds.road,
    ) as HTMLInputElement;
    codPostalInput.value = via;
  };

  private desbloquearCamposPorCPIntroducido = () => {
    const elements = document.getElementsByClassName(this.TAG_BLOQUEADA);
    const elementsAmount = elements?.length;
    // eslint-disable-next-line no-plusplus
    for (let x = 0; x < elementsAmount; x++) {
      // se coge siempre el elemento 0 porque al ir quitando la clase bloqued, la lista de elementos va haciendo más pequeña dinamicamente
      elements[0].removeAttribute(this.TAG_DESABILITADA);
      elements[0].classList.remove(this.TAG_BLOQUEADA);
    }
  };

  private getGLValue = (json: any, gl_type: string) => {
    let elementValue = '' as string;
    for (
      let index = 0;
      index < json.result.address_components.length;
      // eslint-disable-next-line no-plusplus
      index++
    ) {
      const elementType = json.result.address_components[index].types[0];
      if (elementType && elementType === gl_type) {
        if (MisDatosConstants.GL_TYPES_FOR_SHORT_VALUE.includes(elementType)) {
          elementValue = json.result.address_components[index].short_name;
        } else {
          elementValue = json.result.address_components[index].long_name;
        }
      }
    }
    return elementValue?.substring(0, MisDatosConstants.MAX_LENGTH_LOCALIDAD);
  };

  private rellenarLocalidadSiAutocompleteDevuelveLocalidad = (
    directionData: DirectionData,
    json: any,
  ) => {
    let varLocality = directionData?.locality;
    const localityFromGL = this.getGLValue(
      json,
      MisDatosConstants.GL_TYPE_LOCALIDAD,
    );
    if (localityFromGL !== null) {
      varLocality = localityFromGL;
    }
    return varLocality;
  };

  private rellenarCPSiAutocompleteDevuelveCP = (
    directionData: DirectionData,
    domIds: DirectionAutocompleteDomIds,
    json: any,
  ) => {
    let varPostalCode = directionData?.postalCode;
    const postalCodeFromGL = this.getGLValue(
      json,
      MisDatosConstants.GL_TYPE_CODIGO_POSTAL,
    );
    if (
      postalCodeFromGL !== null &&
      postalCodeFromGL !== undefined &&
      postalCodeFromGL !== ''
    ) {
      varPostalCode = postalCodeFromGL;
      this.completarCPconAutocomplete(domIds, postalCodeFromGL);
    }
    return varPostalCode;
  };

  private getPrefijoIdvalue = (prefijoInputId: string) => {
    const prefijoSelector = document.getElementById(
      prefijoInputId,
    ) as HTMLSelectElement;
    const optionElement = prefijoSelector[
      prefijoSelector?.selectedIndex
    ] as HTMLOptionElement;
    return optionElement?.value;
  };

  checkSiPrefijoDesaparecido = (
    selectId: string,
    cp: string,
    directionData: DirectionData,
    prefijosPais: PrefijoPais[],
    setPrefijo: any,
    setTamTelf: any,
    setTempDirectionData: any,
  ) => {
    const selectedPrefijoId = this.getPrefijoIdvalue(selectId);
    if (
      this.expRegCodPostalEspania.test(cp) ||
      selectedPrefijoId === `${MisDatosConstants.ID_PREFIJO_INGLATERRA}`
    ) {
      this.retrievePrefijoByCountry(
        `${MisDatosConstants.ID_PREFIJO_ESPANIA}`,
        directionData,
        prefijosPais,
        setPrefijo,
        setTamTelf,
        setTempDirectionData,
      );
    }
  };

  reiniciarPrefijo = (prefijoInputId: string, prefijo: number) => {
    const prefijoSelector = document.getElementById(
      prefijoInputId,
    ) as HTMLSelectElement;
    prefijoSelector.value = (prefijo as unknown) as string;
  };

  logicaPrefijos = (prefijosVo: any, directionData: DirectionData) => {
    if (this.expRegCodPostalEspania.test(directionData.postalCode)) {
      if (prefijosVo?.prefijo === MisDatosConstants.PREFIJO_INGLATERRA) {
        return false;
      }
    }
    return true;
  };

  retrievePrefijoByCountry = (
    selectedId: string,
    directionData: DirectionData,
    prefijosPais: PrefijoPais[],
    setPrefijo: any,
    setTamTelf: any,
    setTempDirectionData: any,
  ) => {
    const selectedIdNumber = Number(selectedId);
    if (prefijosPais) {
      prefijosPais.forEach((currentValue) => {
        if (currentValue?.id === selectedIdNumber) {
          setPrefijo(currentValue?.prefijo);
          setTempDirectionData({
            ...directionData,
            idPrefTelefono1: currentValue?.id,
          });
          setTamTelf(currentValue.tamanioTelefono);
        }
      });
    }
  };

  public checkGooglePlaceDetailResponse = (response: any) => {
    let accepted = false as boolean;
    if (
      response.data.error === false &&
      response.data.pojos !== null &&
      response.data.pojos[0].codigo !== 'error'
    ) {
      accepted = true;
    }

    return accepted;
  };

  getGeoLocation = (
    cp: boolean,
    country: string,
    postalGeoData: ItemGoogle,
    isPostalCode: boolean,
    postalCode: string,
    directionData: DirectionData,
    setShowAutoC: any,
    setShowAutoC2: any,
    setLocation: any,
    setLocationRoad: any,
    setFirstRoadValue: any,
  ) => {
    setShowAutoC(false);
    setShowAutoC2(false);
    const localPostalGeoData = this.completeInputData(
      country,
      postalGeoData,
      isPostalCode,
      postalCode,
      directionData,
      cp,
    );
    if (cp) {
      MisDatosService.googlePlaceAutoComplete(localPostalGeoData).then(
        (response) => {
          if (this.checkGooglePlaceDetailResponse(response)) {
            setLocation(response.data.pojos);
            setShowAutoC(true);
            setShowAutoC2(false);
          }
        },
      );
    } else {
      MisDatosService.googlePlaceAutoCompleteAddress(localPostalGeoData).then(
        (response) => {
          setFirstRoadValue({});
          if (this.checkGooglePlaceDetailResponse(response)) {
            setLocationRoad(response.data.pojos);
            setShowAutoC2(true);
            setShowAutoC(false);
            setFirstRoadValue(response.data.addressDetailsJson);
          }
        },
      );
    }
  };

  public completeInputData = (
    country: string,
    postalGeoData: ItemGoogle,
    isPostalCode: boolean,
    postalCode: string,
    directionData: DirectionData,
    cp: boolean,
  ) => {
    const localPostalGeoData = postalGeoData;
    localPostalGeoData.input =
      isPostalCode || cp ? postalCode : directionData.roadName;
    localPostalGeoData.types =
      isPostalCode || cp
        ? this.TIPODATOGEOLOCALIZACION_PAIS
        : this.TIPODATOGEOLOCALIZACION_DIRECCIO;
    localPostalGeoData.components = country;
    localPostalGeoData.latitud = directionData.glPlaceLatitud;
    localPostalGeoData.longitud = directionData.glPlaceLongitud;
    localPostalGeoData.idDireccion = directionData.idDireccion;
    localPostalGeoData.tipoC =
      isPostalCode || cp
        ? this.TIPOGEOLOCALIZACION_CODIGOPOSTAL
        : this.TIPOGEOLOCALIZACION_NOMBREVIA;
    localPostalGeoData.tipoR = '';
    localPostalGeoData.sessiontoken = sessionStorage.getItem(
      this.SESSION_TOKEN_KEY,
    ) as string;

    return localPostalGeoData;
  };

  retrieveLocationDetails = (
    isPostalCode: boolean,
    postalCode: string,
    tempDirectionData: DirectionData,
    selectLocation: GoogleLocation,
    findIn: string,
    setShowAutoC: any,
    setShowAutoC2: any,
    setClickSetValue: any,
    setFindIn: any,
    setPostalCode: any,
    setTempDirectionData: any,
    triggerValidation: any,
    setClickRoadValue: any,
    setLockLocality: any,
    setUnlockLocality: any,
    domIds: DirectionAutocompleteDomIds,
  ) => {
    const tipoGeolocalizacion = isPostalCode ? 'CP' : 'NV';
    const data = {
      placeId: selectLocation?.codigo,
      input: isPostalCode ? postalCode : tempDirectionData?.roadTypeDesc,
      idDireccion: tempDirectionData?.idDireccion,
      proceso: '',
      tipoC: tipoGeolocalizacion,
      tipoR: '',
      fields: 'address_component,geometry/location',
      sessiontoken: sessionStorage.getItem('sessiontoken') as string,
    };
    MisDatosService.googlePlaceDetails(data).then((response) => {
      if (response.status === 200) {
        const json = response.data;
        this.actionsWithGooglePlaceDetailsJson(
          tempDirectionData,
          selectLocation,
          findIn,
          setClickSetValue,
          setFindIn,
          setPostalCode,
          setTempDirectionData,
          triggerValidation,
          setClickRoadValue,
          setLockLocality,
          setUnlockLocality,
          domIds,
          json,
        );
        setShowAutoC(false);
        setShowAutoC2(false);
      }
    });
  };

  actionsWithGooglePlaceDetailsJson = (
    tempDirectionData: DirectionData,
    selectLocation: GoogleLocation,
    findIn: string,
    setClickSetValue: any,
    setFindIn: any,
    setPostalCode: any,
    setTempDirectionData: any,
    triggerValidation: any,
    setClickRoadValue: any,
    setLockLocality: any,
    setUnlockLocality: any,
    domIds: DirectionAutocompleteDomIds,
    json: any,
  ) => {
    let varPostalCode;
    let varRoadName;
    let varGlPlaceLongitud;
    let varLocality = '' as string;
    let varGlPlaceLatitud;
    if (json !== null && json.status === this.CORRECT_STATUS) {
      if (findIn === 'cp') {
        varPostalCode = this.getGLValue(
          json,
          MisDatosConstants.GL_TYPE_CODIGO_POSTAL,
        );
        varLocality = this.getGLValue(
          json,
          MisDatosConstants.GL_TYPE_LOCALIDAD,
        );
        varRoadName = tempDirectionData?.roadName;
        varGlPlaceLongitud = json.result.geometry.location.lng;
        varGlPlaceLatitud = json.result.geometry.location.lat;
        setClickSetValue(true);
        setFindIn('');
        this.desbloquearCamposPorCPIntroducido();
        this.completarCPconAutocomplete(domIds, varPostalCode);
        setPostalCode(varPostalCode);
        setTempDirectionData({
          ...tempDirectionData,
          postalCode: varPostalCode,
        });
        triggerValidation('codPostal');
      }
      if (findIn === 'via') {
        varRoadName = this.getGLValue(
          json,
          MisDatosConstants.GL_TYPE_NOMBRE_VIA,
        );
        varGlPlaceLongitud = json.result.geometry.location.lng;
        varGlPlaceLatitud = json.result.geometry.location.lat;
        setClickSetValue(true);
        setFindIn('');
        this.completarViaconAutocomplete(
          domIds,
          json.result.address_components[0].long_name,
        );
        varPostalCode = this.rellenarCPSiAutocompleteDevuelveCP(
          tempDirectionData,
          domIds,
          json,
        );
        setPostalCode(varPostalCode);

        varLocality = this.rellenarLocalidadSiAutocompleteDevuelveLocalidad(
          tempDirectionData,
          json,
        );
        setClickRoadValue(true);
      }
      this.completarLocalidadconAutocomplete(domIds, varLocality);
      const varGlPlaceId = selectLocation?.codigo;
      const varGlPlaceType = this.calculaTipoGelocalizacion(findIn, json);
      if (varLocality !== '' && varLocality !== null) {
        setLockLocality(true);
      }
      if (this.isWithoutLocality(varGlPlaceType)) {
        setUnlockLocality(true);
      }
      setTempDirectionData({
        ...tempDirectionData,
        roadName: varRoadName,
        postalCode: varPostalCode,
        locality: varLocality,
        glPlaceId: varGlPlaceId,
        glPlaceLongitud: varGlPlaceLongitud,
        glPlaceLatitud: varGlPlaceLatitud,
        glPlaceType: varGlPlaceType,
        localityType: '',
      });
    }
  };

  private calculaTipoGelocalizacion = (findIn: string, json: any) => {
    let glPlaceType = '' as string;
    if (findIn === 'cp') {
      glPlaceType = MisDatosConstants.GEOLOCALIZACION_COD_POSTAL;
    } else if (findIn === 'via') {
      glPlaceType = MisDatosConstants.GEOLOCALIZACION_NOMBRE_VIA;
      const postalCodeFromGL = this.getGLValue(
        json,
        MisDatosConstants.GL_TYPE_CODIGO_POSTAL,
      );
      const localityFromGL = this.getGLValue(
        json,
        MisDatosConstants.GL_TYPE_LOCALIDAD,
      );
      if (
        (postalCodeFromGL === null || postalCodeFromGL === '') &&
        (localityFromGL === null || localityFromGL === '')
      ) {
        glPlaceType =
          MisDatosConstants.GEOLOCALIZACION_NV_SIN_CP_Y_SIN_LOCALIDAD;
      } else if (
        (postalCodeFromGL === null || postalCodeFromGL === '') &&
        localityFromGL !== null &&
        localityFromGL !== ''
      ) {
        glPlaceType = MisDatosConstants.GEOLOCALIZACION_NV_SIN_CP;
      } else if (
        postalCodeFromGL !== null &&
        postalCodeFromGL !== '' &&
        (localityFromGL === null || localityFromGL === '')
      ) {
        glPlaceType = MisDatosConstants.GEOLOCALIZACION_NV_SIN_LOCALIDAD;
      }
    }
    return glPlaceType;
  };

  corregirCPIfGibraltar = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
    setPostalCode: any,
    triggerValidation: any,
  ) => {
    const codigoPostal = this.getCorrectedGibraltarPostalCode(e.target.value);
    if (codigoPostal !== e.target.value) {
      e.target.value = codigoPostal;
      const codigoPostalInput = document.getElementById(id) as HTMLInputElement;
      if (codigoPostalInput) {
        codigoPostalInput.value = codigoPostal;
      }
      setPostalCode(codigoPostal);
      triggerValidation('codPostal');
    }
  };

  reiniciarFormularioDireccionFacturacion = (directionData: DirectionData) => {
    const ratioParticularInput = document.getElementById(
      `particular-${directionData?.idDireccion}`,
    ) as HTMLInputElement;
    const ratioPEmpresaInput = document.getElementById(
      `empresa-${directionData?.idDireccion}`,
    ) as HTMLInputElement;
    if (ratioParticularInput) {
      ratioParticularInput.checked = false;
    }
    if (ratioPEmpresaInput) {
      ratioPEmpresaInput.checked = false;
    }
  };

  static getSpainOptionIndexValue = (paisSelect: HTMLSelectElement) => {
    let spainIndex;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < paisSelect?.length; i++) {
      const element = paisSelect?.item(i) as HTMLOptionElement;
      if (element?.value === 'es') {
        spainIndex = element?.index;
      }
    }
    return spainIndex as number;
  };

  isWithoutLocality = (type: string) => {
    if (
      type === MisDatosConstants.GEOLOCALIZACION_NV_SIN_CP_Y_SIN_LOCALIDAD ||
      type === MisDatosConstants.GEOLOCALIZACION_NV_SIN_LOCALIDAD
    ) {
      return true as boolean;
    }
    return false as boolean;
  };
}
